import React, { useMemo } from "react";
import CustomCartDrawer from "../../../CartDrawer/CustomCartDrawer";
import LegacyCartDrawerModal from "./LegacyCartDrawerModal";
import {
  getCustomCartDrawerLayout,
  isStaticCustomCartDrawer,
} from "../../../../constants/custom-cart-drawer-template";

/**
 * Storefront cart drawer entry point.
 * - New "Custom Cart Drawer" template (isStaticCartDrawer): CustomCartDrawer
 * - All existing flows (legacy Custom Cart, openCustomCartDrawer, etc.): LegacyCartDrawerModal
 */
const CartDrawerModal = ({ open, onClose, popupData }) => {
  const useStaticDrawer = isStaticCustomCartDrawer(popupData);

  const layout = useMemo(() => {
    if (!useStaticDrawer) return null;
    return getCustomCartDrawerLayout(popupData);
  }, [useStaticDrawer, popupData]);

  if (useStaticDrawer) {
    return (
      <CustomCartDrawer
        open={open}
        onClose={onClose}
        popupData={popupData}
        layout={layout}
      />
    );
  }

  return <LegacyCartDrawerModal open={open} onClose={onClose} />;
};

export default CartDrawerModal;
